import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import RecipeService from "../../../services/OrderingServices/RecipeService";
import {
  Card,
  CardBody,
  CardHeader,
  Spinner,
  Row,
  Col,
  Badge,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
// import CustomDataTable from "../../../Components/Common/CustomDataTable";
import { Triangle } from "react-loader-spinner";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";

const RecipeDetail = () => {
  const { id } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);

  const fetchDetail = async () => {
    try {
      const response = await RecipeService.getDetail(id);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDetail();
  }, [id]);

  const breadcrumbItems = [
    { title: "Back To List", link: "/receipe-management" },
  ];

  const customStyles = {
    headRow: {
      style: {
        backgroundColor: "#F3F6F9",
        borderBottom: "1px solid #e9ecef",
        fontSize: "14px",
        fontWeight: "600",
        color: "#495057",
      },
    },
    rows: {
      style: {
        minHeight: "60px",
        fontSize: "14px",
        color: "#6c757d",
        "&:hover": {
          backgroundColor: "#f8f9fa",
          cursor: "pointer",
        },
      },
    },
    headCells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
      },
    },
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      width: "80px",
      center: true,
      cell: (row, index) => index + 1,
    },
    {
      name: "Ingredient Name",
      selector: (row) => row.ingredientName,
      sortable: true,
      grow: 2,
      cell: (row) => (
        <span style={{ fontWeight: "500", color: "#212529" }}>
          {row.ingredientName}
        </span>
      ),
    },
    {
      name: "Quantity",
      selector: (row) => row.quantity,
      sortable: true,
      width: "150px",
      cell: (row) => row.quantity,
      left: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      grow: 3,
      cell: (row) => (
        <span style={{ color: "#6c757d", fontSize: "13px" }}>
          {row.description || "No details provided"}
        </span>
      ),
    },
  ];

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <Spinner color="primary" />
      </div>
    );
  }

  if (!data) {
    return (
      <div className="text-center text-danger mt-4">
        Failed to load recipe details
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb
          pageTitle="Recipe"
          title="Recipe Detail"
          breadcrumbItems={breadcrumbItems}
        />

        <Row>
          {/* Recipe Info Card */}
          <Col lg={4} xl={3}>
            <Card className="shadow-sm border-0">
              <CardHeader className="text-white border-0">
                <h5 className="mb-0">Recipe Information</h5>
              </CardHeader>
              <CardBody>
                <div className="mb-4">
                  <h4
                    className="mb-3"
                    style={{ color: "#5B71B9", fontWeight: "600" }}
                  >
                    {data.productName}
                  </h4>
                  <div className="mb-3">
                    <small
                      className="d-block mb-2 text-uppercase"
                      style={{
                        color: "#6c757d",
                        fontSize: "11px",
                        fontWeight: "600",
                        letterSpacing: "0.5px",
                      }}
                    >
                      Description
                    </small>
                    <p
                      className="mb-0"
                      style={{ color: "#495057", fontSize: "14px" }}
                    >
                      {data.description || "No description available"}
                    </p>
                  </div>
                </div>

                <div className="border-top pt-3">
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: "#6c757d", fontSize: "14px" }}>
                      Total Ingredients
                    </span>
                    <Badge
                      color="primary"
                      pill
                      className="px-3 py-2"
                      style={{
                        backgroundColor: "#5B71B9",
                        fontSize: "13px",
                        fontWeight: "600",
                      }}
                    >
                      {data.recipeDetails?.length || 0}
                    </Badge>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>

          {/* Ingredients Table */}
          <Col lg={8} xl={9}>
            <Card className="shadow-sm border-0">
              <CardHeader
                className="border-0"
                style={{ backgroundColor: "#ffffff" }}
              >
                <div className="d-flex justify-content-between align-items-center">
                  <h5
                    className="mb-0"
                    style={{ color: "#212529", fontWeight: "600" }}
                  >
                    Ingredients List
                  </h5>
                  <Badge
                    pill
                    className="px-3 py-2"
                    style={{
                      color: "#fff",
                      fontSize: "13px",
                      fontWeight: "600",
                    }}
                  >
                    {/* {data.recipeDetails?.length || 0} items  */}
                    {data.recipeDetails?.length === 1 ? " 1 item" : `${data.recipeDetails?.length} items`}
                  </Badge>
                </div>
              </CardHeader>
              <CardBody className="p-0">
                {data.recipeDetails && data.recipeDetails.length > 0 ? (
                  <CustomDataTable
                    responsive
                    striped
                    fixedHeader
                    persistTableHead
                    customStyles={customStyles}
                    progressComponent={
                      <div className="my-3">
                        <Triangle
                          visible={true}
                          height="80"
                          width="80"
                          color="#5B71B9"
                          ariaLabel="triangle-loading"
                        />
                        <h5 className="mt-1">Loading...</h5>
                      </div>
                    }
                    columns={columns}
                    data={data.recipeDetails}
                  />
                ) : (
                  <div className="text-center py-5">
                    <div className="mb-3">
                      <i
                        className="ri-file-list-3-line"
                        style={{ fontSize: "3rem", color: "#adb5bd" }}
                      ></i>
                    </div>
                    <p
                      className="mb-0"
                      style={{ color: "#6c757d", fontStyle: "italic" }}
                    >
                      No ingredients found for this recipe
                    </p>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default RecipeDetail;
